import Button from '../../../components/base/Button';

export default function AboutSection() {
  const achievements = [
    { number: '100+', label: 'Premium Machines' },
    { number: 'Pro', label: 'Expert Trainers' },
    { number: 'Clean', label: 'Facilities' },
    { number: '4,650', label: 'KES/Month' }
  ];

  return (
    <section id="about" className="py-12 lg:py-24 bg-white">
      <div className="max-w-7xl mx-auto px-4 lg:px-8">
        <div className="grid lg:grid-cols-2 gap-8 lg:gap-16 items-center">
          {/* Left: Images */}
          <div className="relative">
            {/* Main Image */}
            <div className="relative rounded-xl lg:rounded-3xl overflow-hidden shadow-2xl w-full h-[200px] lg:h-[600px]">
              <img
                src="https://static.readdy.ai/image/6d19b89fe3829a5047d14ddaa9a9b93d/9415567b99bbd6c4e97f0b14b13a2fc3.png"
                alt="HFC Gym Facility"
                className="w-full h-full object-cover object-center"
              />
            </div>

            {/* Floating Card - Hidden on mobile */}
            <div className="hidden lg:block absolute -bottom-8 -right-8 bg-gradient-to-br from-red-600 to-red-700 rounded-3xl p-8 shadow-2xl max-w-xs">
              <div className="text-white">
                <div className="text-5xl font-black mb-2">100+</div>
                <div className="text-red-100 text-lg font-semibold">Strength & Cardio Machines</div>
              </div>
            </div>

            {/* Decorative Element */}
            <div className="absolute -top-6 -left-6 w-32 h-32 bg-red-600/10 rounded-full blur-3xl"></div>
          </div>

          {/* Right: Content */}
          <div>
            <div className="inline-block px-2 py-1 lg:px-4 lg:py-2 bg-red-100 text-red-700 rounded-lg text-[10px] lg:text-sm font-bold mb-2 lg:mb-6 uppercase tracking-wider">
              ABOUT HFC GYM
            </div>

            <h3 className="text-2xl lg:text-6xl font-black text-gray-900 mb-2 lg:mb-6 leading-tight">
              Where <span className="text-red-600">Goals</span> Are Reset & Achieved
            </h3>

            <p className="text-xs lg:text-xl text-gray-600 mb-2 lg:mb-6 leading-relaxed">
              HFC Gym is a space for resetting goals, rebuilding habits, and pushing beyond limits. Whether you're starting fresh, returning stronger, or continuing your fitness journey, we're committed to your progress.
            </p>

            <p className="hidden lg:block text-lg text-gray-600 mb-8 leading-relaxed">
              As one of the biggest gyms in Kenya, HFC Gym is fully equipped for all your training needs. With over 100 high-quality strength and cardio machines, professional trainers providing guidance and free screening for new members, clean and well-maintained facilities, we offer everything you need at affordable rates.
            </p>

            {/* Achievements Grid */}
            <div className="grid grid-cols-4 lg:grid-cols-2 gap-1.5 lg:gap-6 mb-3 lg:mb-8">
              {achievements.map((achievement, index) => (
                <div key={index} className="bg-gray-50 rounded-lg lg:rounded-2xl p-2 lg:p-6 text-center lg:text-left">
                  <div className="text-base lg:text-4xl font-black text-red-600 mb-0 lg:mb-2">
                    {achievement.number}
                  </div>
                  <div className="text-gray-700 font-semibold text-[8px] lg:text-base">
                    {achievement.label}
                  </div>
                </div>
              ))}
            </div>

            {/* CTA */}
            <Button
              href="#contact"
              variant="primary"
              icon="ri-map-pin-line"
              iconPosition="left"
              className="text-xs lg:text-base px-4 py-2 lg:px-8 lg:py-4"
            >
              Visit Us Today
            </Button>
          </div>
        </div>
      </div>
    </section>
  );
}
